<script setup>
import { useI18n } from "vue-i18n";
import { onMounted, ref, computed } from "vue";
import LocalStorage from '@/controller/LocalStorage.js';
import LocaleSwitcher from "@/components/common/locale/LocaleSwitcher.vue";
import RecoverAccountInnerForm from '@/components/recoverPassword/RecoverAccountInnerForm.vue';
import { useRouter } from "vue-router";
const router = useRouter();
const branding = ref(LocalStorage.getBranding());
const { t } = useI18n();
const i18n = useI18n();
const logoToSkip = 'https://yauty.com/public/assets/login/login_logo.png'; //Edge agafa aquest logo, intentem evitar-lo per evitar salts al disseny.
const imgYautyPath = branding.value?.login_logo && branding.value.login_logo != '' && branding.value.login_logo != logoToSkip ? branding.value.login_logo : '../public/assets/login/login_logo.svg';
const imgLogginPath = branding.value?.login_image ?? '../public/assets/login/login_w.jpg';
const yautyLogoGrey= '/assets/logos/yauty-logo-grey.svg';

// Estils concrets per  ala app de google i firefox
const ua = navigator.userAgent.toLowerCase();
if (ua.includes('gsa')) {
  document.documentElement.classList.add('google-app-browser');
};

if (ua.includes('fxios')) {
  document.documentElement.classList.add('firefox-browser');
};

let locale = ref(i18n.locale)
function onChangeInput(newVal) {
  locale.value = newVal;
  localStorage.setItem('yautyLanguage', newVal);
}
onMounted(() => {
  if (localStorage.getItem('yautyLanguage')) {
    locale.value = localStorage.getItem('yautyLanguage') ?? 'es';
  }
});


const isRecovery = computed(() => {
  const recoveryPath = [
    "recoverAccount"
  ];
  return recoveryPath.includes(router.currentRoute.value.name);
});

</script>
<template class="register" style="padding-left:0px">
  <section class="register-container">
    <div class="register-section--left">
      <img :src="imgLogginPath" />
    </div>
    <div class="register-section--right">
      <div class="register-logo">
        <img :src="imgYautyPath" style="max-width:250px;"/>
      </div>
      <div class="register-message_1">
        {{ t('field.recover_password') }}
      </div>
      <div class="register-message_2">
        {{ $t('field.write_mail') }}
      </div>
      <div class="register-form">
        <RecoverAccountInnerForm />
      </div>
      <div class="powered-message grey-text">Powered by: <img :src="yautyLogoGrey" style="width: 50px; height: auto; margin-left: 5px;" /></div>
    </div>
  </section>
  <div class="language-selector"  :class="isRecovery ? 'recovery' : ''">
    <div class="language__selector">
      <LocaleSwitcher :lang="locale" @changeInput="onChangeInput" :mode="1"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.register-container {
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: center;
  height: calc(100vh - 60px);
  .register-section--left {
    width: 50dvw;
    height: 100dvh;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .register-section--right {
    display: flex;
    flex-direction: column;
    padding-left: 8rem;
    margin-top: 10dvh;
    height: 90vh;
    position: relative;
    
    max-width: 466px; 
    
    .register-message_1 {
      text-align: left;
      font: normal normal normal 51px/29px 'CircularStd-Book';
      letter-spacing: -2.55px;
      color: #000000;
      margin-top: 60px;
      line-height: 0.9;
    }
    .register-message_2 {
      text-align: left;
      font: normal normal normal 18px/29px 'CircularStd-Book';
      letter-spacing: -0.9px;
      color: #000000;
      opacity: 1;
      margin-top: 28px;
    }
    .register-form {
      margin-top: 16px;
    }
    .powered-message {
      margin-top: auto;
      margin-bottom: 1.5rem;
      text-align: left;
      font: normal normal normal 16px/15px 'CircularStd-Book';
      letter-spacing: 0px;
      opacity: 1;
      @media (max-width: 576px) {
        margin-bottom: 6rem;
      }
    }
  }
  @media (min-width: 360px) and (max-width: 768px) {
    grid-template-columns: 0% 100%;
    .register-section--left {
      width: 0;
      img {
        width: 0;
        object-fit: cover;
      }
    } 
    .register-section--right {
      padding-left: 4rem;
    }
  }
  

  @media (min-width: 768px) and (max-width: 1300px) {
    grid-template-columns: 50% 50%;
    .register-section--left {
      width: 50dvw;
      img {
        width: 50dvw;
        object-fit: cover;
      }
    }
    .register-section--right {
      padding-left: 0rem;
    }
  }
}
.language-selector {
    position: absolute;
    bottom: -15px;
    right: 2rem;
    width: 175px;
    z-index: 5;
    margin-bottom: 0.6rem
    
    
}

@media (max-width: 600px) {
  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      margin-top: 10dvh;
      padding-left: inherit;
      height: 90dvh;
      text-align: center;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
    }
    .powered-message {
      justify-self: center;
      align-self: center;
      margin-top: 0rem;
    }

  }
}
@media (max-width: 580px) {
  
  .language-selector {
    bottom: 3.5dvh;
		left: 50%;
		transform: translateX(-50%);
		right: unset;
  }
  @supports (-ms-ime-align:auto) {
		.language-selector{
      margin-bottom: 6rem;
    }	

    .language-selector {
      bottom: 3dvh;
    }

	}
}
@media (min-width: 581px) and (max-width: 1024px) and (orientation: portrait) {
  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    height: 100vh;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      padding-left: inherit;
      max-width: 100%;
      margin-top: 10dvh;
      height: 90vh;
      text-align: center;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
    }
  }
  .language-selector {
    position: absolute;
		right: auto;
		bottom: 10dvh;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		width: 175px;
		background: transparent;
		justify-self: center;
  }

  
  .powered-message{
    justify-self: center;
    align-self: center;
    margin-top: 0rem;
    bottom: 2rem;
  }
}

@media (min-width: 769px) and (max-width: 1300px) and (orientation: landscape)  {
  .register-container {
    grid-template-columns: auto;
    max-width: 80%;
    margin: auto;
    height: 80vh;
    .register-section--left {
      display: none;
    }
    .register-section--right {
      padding-left: inherit;
      max-width: 90dvh;
      margin-top: 10dvh;
      text-align: center;
      height: 65vh;
      .register-message_1, .register-message_2 {
        text-align: center;
      }
    }
    .powered-message{
      justify-self: center;
      align-self: center;
      margin-top: 0rem;
    }
  }
  .language-selector{
		right: 1rem;
	}
}

@media (min-width: 1301px) and (max-width: 1365px) and (orientation: landscape)  {
  .register-section--right {
    padding-left: 3rem !important;
  }
}


.recovery{
  @media (min-width: 1301px) and (orientation: landscape) {
    margin-bottom: 2.5rem;
  }
}

@media (max-width: 950px) and (orientation: landscape) {
  .register-section--right {
	margin-top: 15dvh !important;
	height: 150dvh !important;
	top: 0;
	padding-bottom: 8rem !important;
	max-width: none !important;
  align-items: center !important;
  padding-left: 0 !important;
  }
  .register-container{
	height: 160dvh !important;
	min-height: 650px;
	padding-bottom: 6rem !important;
  }
  
  .language-selector {
    position: absolute !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto !important;
    margin: 0 !important;
    z-index: 10 !important;
	bottom: 2dvh !important;
  }
  
  .powered-message {
    margin-bottom: 8rem !important;
    position: relative !important;
    z-index: 1 !important;
  }
}

@supports (-moz-appearance: none) {
  @media (min-width: 769px) and (max-width: 1300px) and (orientation: landscape)  {
    .language-selector{
      margin-bottom: 3rem !important;
      right: 2rem !important;
    }
  }
}

/* Estilos específicos para Google App */
@media (max-width: 620px) and (orientation: portrait) {
	.google-app-browser  {
		.register-section--right {
			height: calc(85dvh + 20dvh) !important;
		}
		
		.language-selector {
			bottom: -0.5rem !important;
		}
		
		.powered-message {
			margin-bottom: 9rem !important;
		}
	}
	.firefox-browser  {
		.powered-message{
			margin-bottom: 5rem !important;
		}
    .language-selector{
      bottom: 0rem !important;
    }
	}
}


</style>
